/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseReasoningTextDoneEvent = {
  type: "response.reasoning_text.done";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  contentIndex: number;
  text: string;
};

/** @internal */
export const ResponseReasoningTextDoneEvent$inboundSchema: z.ZodType<
  ResponseReasoningTextDoneEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.reasoning_text.done"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  content_index: z.number().int(),
  text: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "content_index": "contentIndex",
  });
});
/** @internal */
export type ResponseReasoningTextDoneEvent$Outbound = {
  type: "response.reasoning_text.done";
  sequence_number: number;
  item_id: string;
  output_index: number;
  content_index: number;
  text: string;
};

/** @internal */
export const ResponseReasoningTextDoneEvent$outboundSchema: z.ZodType<
  ResponseReasoningTextDoneEvent$Outbound,
  z.ZodTypeDef,
  ResponseReasoningTextDoneEvent
> = z.object({
  type: z.literal("response.reasoning_text.done"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  contentIndex: z.number().int(),
  text: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    contentIndex: "content_index",
  });
});

export function responseReasoningTextDoneEventToJSON(
  responseReasoningTextDoneEvent: ResponseReasoningTextDoneEvent,
): string {
  return JSON.stringify(
    ResponseReasoningTextDoneEvent$outboundSchema.parse(
      responseReasoningTextDoneEvent,
    ),
  );
}
export function responseReasoningTextDoneEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseReasoningTextDoneEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseReasoningTextDoneEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseReasoningTextDoneEvent' from JSON`,
  );
}
